/**
 * @generated SignedSource<<a196c50ae86a6c923bf8da291ac6a70a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type positionFocusArea_AtlassianSearchPage$data = {
  readonly __typename: "MercuryFocusArea";
  readonly health: {
    readonly key: string;
  } | null | undefined;
  readonly name: string;
  readonly status: {
    readonly key: string;
  };
  readonly " $fragmentType": "positionFocusArea_AtlassianSearchPage";
};
export type positionFocusArea_AtlassianSearchPage$key = {
  readonly " $data"?: positionFocusArea_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"positionFocusArea_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "key"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "positionFocusArea_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "MercuryFocusAreaStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": (v0/*: any*/)
    },
    {
      "concreteType": "MercuryFocusAreaHealth",
      "kind": "LinkedField",
      "name": "health",
      "plural": false,
      "selections": (v0/*: any*/)
    }
  ],
  "type": "MercuryFocusArea"
};
})();

(node as any).hash = "e9b519ecce5fbf8e7515fc87b88d3908";

export default node;
